
import {
  getGiveawayActions, persistGiveawayActions,
} from 'Helpers/Product/persisted-giveaway-actions';
import store from 'Redux/store';
import env from 'Env';

const MAX_GIVEAWAY_ACTIONS = env.algolia.maxGiveawayActions || 10;

export const GIVEAWAY_CAMPAIGN_SLUG = 'power-up-your-play-win-a-monster-omen-45l-gaming-rig';
export const GIVEAWAY_CAMPAIGN_ID = '69cbee2526178fd73b053f69';
export const GIVEAWAY_CAMPAIGN_URL = 'https://www.microsoft.com/en-us/p/omen-gaming-hub/9nqdw009t0t5?cid=landingpage&utm_so[…]m_medium=competition&utm_campaign=powerupyourplay&utm_id=OGH';
export const SET_GIVEAWAY_ACTIONS = 'frontend/giveaway/SET_GIVEAWAY_ACTIONS';
export function saveGiveawayActions(actions) {
  if ((actions || []).length > MAX_GIVEAWAY_ACTIONS) actions.shift();
  persistGiveawayActions(actions);
  store.dispatch({ type: SET_GIVEAWAY_ACTIONS, payload: actions });
}

/**
 * Adds or updates a giveaway action for a specific game slug.
 * @param {string} slug - The game slug.
 * @param {object} actionData - The action data to associate with the slug.
 */
export function saveGiveawayAction(slug, actionData) {
  const actions = getGiveawayActions();

  const existingIndex = actions.findIndex(action => action.slug === slug);

  if (existingIndex !== -1) {
    actions[existingIndex] = { ...actions[existingIndex], ...actionData };
  } else {
    actions.push({ slug, ...actionData });
  }

  saveGiveawayActions(actions);
}

/**
 * Removes a giveaway action for a specific game slug.
 * @param {string} slug - The game slug
 */
export function removeGiveawayAction(slug) {
  const actions = getGiveawayActions();
  const updatedActions = actions.filter(action => action.slug !== slug);
  saveGiveawayActions(updatedActions);
}

/**
  * Removes all giveaway actions.
  */
export function removeAllGiveawayActions() {
  persistGiveawayActions([]);
  store.dispatch({ type: SET_GIVEAWAY_ACTIONS, payload: [] });
}

